import React from 'react'
import { renderRoutes } from 'react-router-config'
import PropTypes from 'prop-types'

import { Container } from './styles'

function Root({ route }) {
  return <Container>{renderRoutes(route.routes)}</Container>
}

Root.propTypes = {
  route: PropTypes.object.isRequired,
}

export default Root
